export default __webpack_public_path__ + "a346d9e138783a24f6a1c4e949ccea72.svg";